exports['UTF-16BE'] = require('./charset-recog-utf-16-be');

exports['UTF-16LE'] = require('./charset-recog-utf-16-le');

exports['UTF-32BE'] = require('./charset-recog-utf-32-be');

exports['UTF-32LE'] = require('./charset-recog-utf-32-le');


//////////////////
// WEBPACK FOOTER
// ./node_modules/charset-detector/src/unicode/index.js
// module id = 1814
// module chunks = 0